import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { DownOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Modal, Pagination, message, Space, Dropdown, DatePicker, Checkbox } from 'antd'
import Icon from 'src/@core/components/icon'
import { motion } from 'framer-motion'
import { messageInfo } from 'src/components/Message'
import PerfectScrollbarComponent from 'react-perfect-scrollbar'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import dayjs from 'dayjs'

import { androidLocalRefresh, androidLocalRecordQuestionRrecycleGet } from 'src/@api/android'
import { Fragment, useCallback, useEffect, useRef, useState } from 'react'

import { delFile } from 'src/@api/dashboard'
import { readUserEmail } from 'src/utils/readAndroidLocalContext'
import Image from 'next/image'
import styles from './index.module.scss'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import io from 'socket.io-client'
import { useTranslation } from 'src/utils/i18n'
import { useAndroidDevicePagedData } from 'src/hooks/useAndroidDevicePagedData'
import ContentLoading from 'src/components/ContentLoading'
import DateRangeFilter from 'src/components/DateRangeFilter'
import { buildTimeParams, buildPresetTimeParams } from 'src/utils/dateRangeParams'

const { RangePicker } = DatePicker

// 转换毫秒
function convertTimeStringToMilliseconds(timeString) {
  const regex = /^(\d+)([sm])$/
  const match = timeString.match(regex)

  if (!match) {
    throw new Error('Invalid time string format')
  }

  const value = parseInt(match[1])
  const unit = match[2]

  if (unit === 's') {
    return value * 1000 // 将秒转换为毫秒
  } else if (unit === 'm') {
    return value * 60 * 1000 // 将分钟转换为毫秒
  } else {
    throw new Error('Invalid time unit')
  }
}

// 秒转时分秒
function formatSeconds(seconds) {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  return (
    ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + Math.floor(remainingSeconds)).slice(-2)
  )
}

// 秒转分秒
function formatSeconds2(seconds) {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return ('0' + minutes).slice(-2) + ':' + ('0' + Math.floor(remainingSeconds)).slice(-2)
}

const RecordSurround = () => {
  const items = [
    {
      label: '2m',
      key: '2m'
    },
    {
      label: '5m',
      key: '5m'
    },
    {
      label: '10m',
      key: '10m'
    },
    {
      label: '15m',
      key: '15m'
    },
    {
      label: '30m',
      key: '30m'
    }
  ]
  const [messageApi, contextHolder] = message.useMessage()
  const [countdown, setCountdown] = useState(0)
  const { t } = useTranslation('common')
  const {
    context,
    data: deviceData,
    loading: isLoading,
    loadNext,
    reload,
    setDateRange
  } = useAndroidDevicePagedData({ source: 'local', category: 'LIVE_AUDIO', limit: 50 })
  const contextRef = useRef(context)
  const countdownTimerRef = useRef(null)
  const recordTimeoutRef = useRef(null)
  const socketRef = useRef(null)
  const socketEmitTimeoutRef = useRef(null)
  contextRef.current = context
  const recordStorageKey = context?.identityKey ? `type36:${context.identityKey}` : 'type36'

  const recordNow = async e => {
    const time = convertTimeStringToMilliseconds(e)
    const requestKey = context?.requestKey
    const deviceId = context?.username
    if (!requestKey || !deviceId) return

    if (
      sessionStorage.getItem(recordStorageKey) &&
      JSON.parse(sessionStorage.getItem(recordStorageKey)).date > new Date().getTime()
    ) {
      return
    }

    const result = await androidLocalRefresh({ device_id: deviceId, type: '36', time })
    if (contextRef.current?.requestKey === requestKey && result.code === 0) {
      sessionStorage.setItem(recordStorageKey, JSON.stringify({ date: new Date().getTime() + time + 30000 }))
      setBtnLoading(true)
      setCountdown(time / 1000)

      // 倒计时
      if (countdownTimerRef.current) clearInterval(countdownTimerRef.current)
      countdownTimerRef.current = setInterval(() => {
        setCountdown(val => {
          if (val == 0) {
            clearInterval(countdownTimerRef.current)
            countdownTimerRef.current = null

            return 0
          }

          return (val = val - 1)
        })
      }, 1000)
      getRecord(time, requestKey, deviceId, recordStorageKey)
    }
  }

  const [btnLoading, setBtnLoading] = useState(false)

  // 数据
  const [allVideoData, setAllVideoData] = useState([])
  const [filterVideoData, setFilterVideoData] = useState([])
  const [videoDate, setVideoDate] = useState([])
  const [checkedDate, setCheckedDate] = useState([])
  const [checkedAll, setCheckAll] = useState(false)
  const [vedioUrl, setVedioUrl] = useState('')

  const [showRecordTime, setShowRecordTime] = useState(false)
  const [showDate, setShowDate] = useState(false)
  const [tips, setTips] = useState('')
  const [date, setDate] = useState(['All'])
  const rangeDom = useRef(null)
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [dates, setDates] = useState([])

  useEffect(() => {
    const mappedData = deviceData.map(row => ({
      date: dayjs(row.date).format('YYYY-MM-DD HH:mm:ss'),
      url: `https://cos.spyx.com/${row.thumb.url}`,
      thumb: row.thumb,
      id: row.date
    }))
    setAllVideoData(mappedData)
  }, [deviceData])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100) loadNext()
  }, [loadNext, scroll])

  useEffect(() => {
    const interval = setInterval(() => setBtnLoading(Boolean(sessionStorage.getItem(recordStorageKey))), 1000)

    return () => clearInterval(interval)
  }, [recordStorageKey])

  // // 轮询数据
  // useEffect(() => {
  //   setInterval(() => {
  //     setPage(1)
  //   }, 1000 * 200)
  // }, [])

  // 50秒后提示录制状态
  const getRecord = (time, requestKey, deviceId, storageKey) => {
    if (recordTimeoutRef.current) clearTimeout(recordTimeoutRef.current)
    recordTimeoutRef.current = setTimeout(async () => {
      try {
        const result = await androidLocalRecordQuestionRrecycleGet({ type: 36, device_id: deviceId })
        if (contextRef.current?.requestKey !== requestKey) return
        if (result.msg) {
          reload()
        } else {
          setTips('The target device is turned off or not connected to the network, please make sure it is turned on')
        }
      } catch {
        if (contextRef.current?.requestKey === requestKey) {
          setTips('The target device is turned off or not connected to the network, please make sure it is turned on')
        }
      } finally {
        sessionStorage.removeItem(storageKey)
        recordTimeoutRef.current = null
      }
    }, time + 8000)
  }

  // 打开视频
  const [videoOpen, setVideoOpen] = useState(false)
  const [currentVideo, setCurrentVideo] = useState('')

  // 下载音频
  const downloadVideo = url => {
    const _url = url
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style.display = 'none'
        const url = window.URL.createObjectURL(blob)
        a.href = url
        const _arr = _url.split('/')
        a.download = _arr[_arr.length - 1]
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      })
  }

  useEffect(() => {
    if (filterVideoData.length === 0 || filterVideoData[0].duration) return

    for (const i in filterVideoData) {
      if (filterVideoData[i].thumb?.duration) {
        setFilterVideoData(val => {
          val[i].duration = formatSeconds(filterVideoData[i].thumb.duration / 1000)

          // 设置多选框值
          val[i].checked = false

          return [...val]
        })
      } else {
        // 设置时长
        let audio = new Audio(filterVideoData[i].url)

        audio.addEventListener('loadeddata', function (e) {
          console.log(audio.duration)

          setFilterVideoData(val => {
            val[i].duration = formatSeconds(audio.duration)

            // 设置多选框值
            val[i].checked = false

            return [...val]
          })
        })
      }
    }
  }, [filterVideoData])

  const audio = url => {
    setCurrentVideo(url)
    setVideoOpen(true)
  }

  // 日期变化 -> 交给接口按日期重新拉取（列表不再是「只筛已加载的那几十条」）
  useEffect(() => {
    if (date.length === 1 && date[0] !== 'All') {
      // 快捷选项：换算成接口区间
      const { startTime, endTime } = buildPresetTimeParams(date[0])
      setDateRange({ startTime, endTime })
    } else if (date.length === 2) {
      // 自定义区间
      const { startTime, endTime } = buildTimeParams(date)
      setDateRange({ startTime, endTime })
    } else {
      // All：清除筛选
      setDateRange(null)
    }
  }, [date, setDateRange])

  // 本地兜底筛选：接口按日期返回后，用同一区间再筛一次（接口不支持该参数时仍然可用）
  const filterDate = useCallback(
    (ago, now) => {
      if (!ago || !now) {
        setFilterVideoData([...allVideoData])
      } else {
        const _value = JSON.parse(JSON.stringify(allVideoData))
        const _arr = []
        for (const item of _value) {
          const _time = dayjs(item.date).valueOf()
          if (ago <= _time && _time <= now) {
            _arr.push(item)
          }
        }
        setFilterVideoData([..._arr])
      }
    },
    [allVideoData]
  )

  // 数据变化（含接口返回）后刷新展示列表
  useEffect(() => {
    if (date.length === 1 && date[0] !== 'All') {
      const { startTime, endTime } = buildPresetTimeParams(date[0])
      filterDate(startTime, endTime)
    } else if (date.length === 2) {
      const { startTime, endTime } = buildTimeParams(date)
      filterDate(startTime, endTime)
    } else {
      filterDate()
    }
  }, [date, filterDate])

  // all checked改变
  const onChangeCheckedAll = e => {
    setCheckAll(e.target.checked)
    setFilterVideoData(val => {
      for (const item of val) {
        item.checked = e.target.checked
      }

      return [...val]
    })
  }

  // 时间checked改变
  const onChangeChecked = (e, i) => {
    setFilterVideoData(val => {
      val[i].checked = e.target.checked
      const _arr = []
      if (!e.target.checked) {
        setCheckAll(false)
      } else {
        const _arr2 = []
        for (const _item of val) {
          if (_item.date.split(' ')[0] === val[i].date.split(' ')[0]) {
            _arr.push(_item.checked)
          }
          _arr2.push(_item.checked)
        }
        if (!_arr2.includes(false)) setCheckAll(true)
      }

      return [...val]
    })
  }

  const onApply = () => {
    if (!from || !to) return
    setDate([from, to])
    setShowDate(false)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Record surround')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  // 停止录制
  const stop = () => {
    const requestKey = context?.requestKey
    const deviceId = context?.username
    if (!requestKey || !deviceId || socketRef.current) return

    const currentSocket = io(process.env.NEXT_PUBLIC_BASE_URL)
    socketRef.current = currentSocket
    const senderId = deviceId
    const receiverId = deviceId
    const message = { handleType: 'live', type: '36', id: deviceId }

    currentSocket.on('connect', () => {
      if (contextRef.current?.requestKey !== requestKey) {
        currentSocket.disconnect()
        socketRef.current = null

        return
      }

      sessionStorage.removeItem(recordStorageKey)
      if (recordTimeoutRef.current) {
        clearTimeout(recordTimeoutRef.current)
        recordTimeoutRef.current = null
      }
      if (countdownTimerRef.current) {
        clearInterval(countdownTimerRef.current)
        countdownTimerRef.current = null
      }
      socketEmitTimeoutRef.current = setTimeout(() => {
        currentSocket.emit('private_message', { senderId, receiverId, message })
        currentSocket.disconnect()
        socketRef.current = null
        socketEmitTimeoutRef.current = null
      }, 1000)
    })
  }

  useEffect(() => {
    return () => {
      if (countdownTimerRef.current) clearInterval(countdownTimerRef.current)
      if (recordTimeoutRef.current) clearTimeout(recordTimeoutRef.current)
      if (socketEmitTimeoutRef.current) clearTimeout(socketEmitTimeoutRef.current)
      if (socketRef.current) socketRef.current.disconnect()
      countdownTimerRef.current = null
      recordTimeoutRef.current = null
      socketEmitTimeoutRef.current = null
      socketRef.current = null
    }
  }, [context?.requestKey])

  const del = async () => {
    const requestKey = context?.requestKey
    const deviceId = context?.username
    if (!requestKey || !deviceId) return

    const _arr = []
    for (const item of filterVideoData) {
      if (item.checked) {
        _arr.push(item.id)
      }
    }

    const res = await delFile({
      username: readUserEmail(),
      params: {
        category: 'LIVE_AUDIO',
        deviceUdid: deviceId,
        idList: _arr
      }
    })
    if (contextRef.current?.requestKey === requestKey && res.data.status) {
      messageInfo(t('Delete success'))
      reload()
    }
  }

  // 日期按钮
  const button1 = () => (
    <div
      className='w-[calc(50%-5px)] h-[35px] bg-[#F8F8F8] border border-[#E5E7EB] rounded-[8px] flex justify-center items-center cursor-pointer relative max-px-[10px] Blds:w-auto Blds:min-w-[172px]'
      onClick={e => {
        e.stopPropagation()
        setShowDate(val => !val)
      }}
    >
      <Image className='ml-[2px]' src='/images/record-screen/calendar.svg' width={20} height={20} alt='calendar' />
      <span className='text-[14px] text-[#000] mr-[16px] ml-[5px]'>
        {date.length === 1 && date[0]}
        {date.length === 2 && (
          <>
            {date[0]} ~ {date[1]}
          </>
        )}
      </span>
      <motion.div initial={{ rotate: 0 }} animate={{ rotate: showDate ? 180 : 0 }} transition={{ duration: 0.2 }}>
        <Image src='/images/record-screen/drop-down.svg' width={20} height={20} alt='drop down' />
      </motion.div>

      {/* 下拉框 */}
      {showDate && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
          className='w-full drop-shadow-[0_0_3px_rgba(0,0,0,0.1)] bg-[#FFF] rounded-[6px] flex flex-col text-[14px] text-[#666666] absolute top-[38px] p-[10px] z-30 relative'
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <div className='border border-[#E5E5E5] rounded-[3px] text-[14px] text-[rgba(0,0,0,0.9)]'>
            <div
              className='py-[3px] px-[16px]'
              onClick={() => {
                setDate(['All'])
                setShowDate(false)
              }}
            >
              {t('All')}
            </div>
            <div
              className='py-[3px] px-[16px]'
              onClick={() => {
                setDate(['Today'])
                setShowDate(false)
              }}
            >
              {t('Today')}
            </div>
            <div
              className='py-[3px] px-[16px]'
              onClick={() => {
                setDate(['Last 7 days'])
                setShowDate(false)
              }}
            >
              {t('Last 7 days')}
            </div>
            <div
              className='py-[3px] px-[16px]'
              onClick={() => {
                setDate(['Last 14 days'])
                setShowDate(false)
              }}
            >
              {t('Last 14 days')}
            </div>
            <div
              className='py-[3px] px-[16px]'
              onClick={() => {
                setDate(['Last 30 days'])
                setShowDate(false)
              }}
            >
              {t('Last 30 days')}
            </div>
            <div
              className='py-[3px] px-[16px]'
              onClick={() => {
                const currentDate = new Date()
                const xxDaysAgo = currentDate.setDate(currentDate.getDate() - 365)
                console.log('xxxx', xxDaysAgo, new Date().getTime())
                setDate(['Last Year'])
                setShowDate(false)
              }}
            >
              {t('Last Year')}
            </div>
          </div>
          <div className='w-full relative'>
            <div className='text-[12px] text-[#666666] mt-[10px]'>From</div>
            <div className='border border-[#E5E5E5] rounded-[3px] h-[24px] w-full text-[10px] text-[rgba(0,0,0,0.9)] px-[16px] flex items-center mb-[5px]'>
              {from}
            </div>
            {t('To')}
            <div className='border border-[#E5E5E5] rounded-[3px] h-[24px] w-full text-[10px] text-[rgba(0,0,0,0.9)] px-[16px] flex items-center'>
              {to}
            </div>
            <RangePicker
              className='absolute w-full h-full top-0 left-0 opacity-0'
              ref={rangeDom}
              onOpenChange={open => {
                console.log(open)
              }}
              value={dates}
              onCalendarChange={(dates, dateStrings, info) => {
                setDates([...dates])
                setFrom(dateStrings[0])
                setTo(dateStrings[1])
                console.log('xxxx', dates, dateStrings, info)
              }}
              allowClear={false}
            />
          </div>
          <div
            className={`${from && to ? 'cursor-pointer' : 'opacity-60'
              } mt-[15px] w-full h-[24px] flex justify-center items-center bg-[#FFCF55] rounded-[3px] text-[14px] text-[#000000]`}
            onClick={() => onApply()}
          >
            {t('APPLY')}
          </div>
          <div
            className='mt-[11px] w-full h-[24px] flex justify-center items-center text-[14px] text-[#000000] bg-[#E5E5E5] rounded-[3px] cursor-pointer'
            onClick={() => setShowDate(false)}
          >
            {t('CANCEL')}
          </div>
        </motion.div>
      )}
    </div>
  )

  // 录制按钮
  const button2 = () => (
    <motion.div
      className={`${btnLoading ? 'bg-[#F33737]' : 'bg-[#FFCF55]'
        } w-[calc(50%-5px)] h-[35px] px-[10px] rounded-[8px] flex justify-center items-center cursor-pointer relative Blds:w-[152px]`}
      onClick={e => {
        e.stopPropagation()
        if (btnLoading) {
          stop()
        } else {
          setShowRecordTime(val => !val)
        }
      }}
    >
      <span className={`${btnLoading ? 'text-[#FFF]' : 'text-[#000]'} text-[14px] mr-[16px]`}>
        {btnLoading ? t('Stop') : t('Record Now')}
      </span>
      {!btnLoading && (
        <motion.div
          initial={{ rotate: 0 }}
          animate={{ rotate: showRecordTime ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <Image src='/images/record-screen/drop-down.svg' width={20} height={20} alt='drop down' />
        </motion.div>
      )}
      {btnLoading && (
        <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#F33737] rounded-[50%] inline-block box-border animate-spin'></div>
      )}

      {/* 下拉框 */}
      {showRecordTime && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
          className='w-full drop-shadow-[0_0_3px_rgba(0,0,0,0.1)] bg-[#FFF] rounded-[6px] flex flex-col text-[14px] text-[#666666] absolute top-[38px] py-[5px] z-30 relative'
          onClick={e => {
            e.stopPropagation()
          }}
        >
          {
            items.map(item => (
              <div className='w-full px-[17px] py-[2px] cursor-pointer' key={item.key}
                onClick={e => {
                  setShowRecordTime(false)
                  setTips('')
                  recordNow(item.label)
                }}>
                {item.label}
              </div>
            ))
          }
          {/* <div
            className='w-full px-[17px] py-[2px] cursor-pointer'
            onClick={e => {
              setShowRecordTime(false)
              setTips('')
              recordNow('15s')
            }}
          >
            15S
          </div>
          <div
            className='w-full px-[17px] py-[2px] cursor-pointer'
            onClick={e => {
              setShowRecordTime(false)
              setTips('')
              recordNow('30s')
            }}
          >
            30S
          </div>
          <div
            className='w-full px-[17px] py-[2px] cursor-pointer'
            onClick={e => {
              setShowRecordTime(false)
              setTips('')
              recordNow('1m')
            }}
          >
            1m
          </div> */}
        </motion.div>
      )}
    </motion.div>
  )

  const loading = () => (
    <div className='w-full mt-[11px] px-[16px] Blds:px-[32px] Blds:mb-[13px] Blds:mt-0 flex items-center'>
      <Image src='/images/record-screen/countdown.svg' width={28} height={28} alt='countdown' />
      <span className='ml-[3px] text-[13px] text-[#007AFF]'>Recording... Time remaining&nbsp;</span>
      <span className='text-[13px] text-[#F33737]'>{formatSeconds2(countdown)}</span>
    </div>
  )

  return (
    <div className={styles.box}>
      {/* 提示框 */}
      {tips && (
        <div className='w-full bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] flex flex-col justify-center items-center mb-[10px] p-[15px] relative'>
          <div className='w-full flex justify-end pb-[10px]'>
            <Image
              src='/images/record-screen/close.svg'
              width={20}
              height={20}
              alt='close'
              onClick={() => {
                setTips('')
              }}
            />
          </div>
          <p className='text-[13px] text-[#F11E34] font-[600]'>{tips}</p>
          <div className='w-full flex justify-center pt-[8px]'>
            <Image src='/images/record-screen/warning.svg' width={30} height={30} alt='warning' />
          </div>
        </div>
      )}
      {btnLoading && <div className='w-full Bld:hidden'>{loading()}</div>}
      <div
        className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col overflow-auto relative'
        onClick={() => {
          setShowRecordTime(false)
          setShowDate(false)
        }}
      >
        {btnLoading && <div className='w-full Blds:hidden'>{loading()}</div>}
        <div
          className={`${btnLoading ? 'pt-[10px] Blds:pt-[15px]' : 'pt-[15px]'
            } w-full h-[108px] pb-[14px] flex flex-col justify-between Blds:hidden`}
        >
          <div className='flex justify-between px-[10px]'>
            <DateRangeFilter value={date} onChange={setDate} variant='gray' className='w-[calc(50%-5px)] Blds:w-auto Blds:min-w-[172px]' />
            {button2()}
          </div>
          <div className='flex justify-between px-[16px]'>
            <Checkbox
              className='text-[18px] font-[600] text-[#000]'
              checked={checkedAll}
              onChange={e => onChangeCheckedAll(e)}
            >
              {t('All Select')}
            </Checkbox>
            <Image
              className='ml-[10px] cursor-pointer'
              src='/images/record-screen/del.svg'
              width={30}
              height={30}
              alt='del'
              onClick={del}
            />
          </div>
        </div>
        <div className='w-full h-[80px] flex justify-between items-center px-[32px] Bld:hidden'>
          {button2()}
          <DateRangeFilter value={date} onChange={setDate} variant='gray' className='w-[calc(50%-5px)] Blds:w-auto Blds:min-w-[172px]' />
          <div className='flex justify-between items-center'>
            <Checkbox
              className='text-[18px] font-[600] text-[#000]'
              checked={checkedAll}
              onChange={e => onChangeCheckedAll(e)}
            >
              {t('All Select')}
            </Checkbox>
            <Image
              className='ml-[21px] cursor-pointer'
              src='/images/record-screen/del.svg'
              width={30}
              height={30}
              alt='del'
              onClick={del}
            />
          </div>
        </div>
        <div ref={dom} className='flex-1 border-t border-[#E5E7EB] overflow-auto py-[10px] Blds:py-[15px]'>
          <div className='flex-wrap grid gap-x-[10px] gap-y-[5px] Blds:gap-y-[10px] sm:grid-cols-1 grid-cols-1 flex-1 overflow-auto px-[14px] Blds:px-[32px]'>
            {filterVideoData.map((item, i) => (
              <Fragment key={i}>
                {/* 移动端 */}
                <div className='Blds:hidden'>
                  <div
                    className='rounded-[6px] px-[15px] py-[12px] flex flex-col shadow-[0_0_5px_rgba(0,0,0,0.3)] my-[5px] cursor-pointer'
                    onClick={() => {
                      setVedioUrl(item.url)
                    }}
                  >
                    <div className='w-full flex items-center justify-between'>
                      <span className='text-[16px] text-[#333333] font-[600]'>{item.date}</span>
                      <Checkbox
                        checked={item.checked}
                        onChange={e => {
                          e.stopPropagation()
                          setVedioUrl('')
                          onChangeChecked(e, i)
                        }}
                        className='text-[#ac9999] text-[14px]'
                      ></Checkbox>
                    </div>
                    <div className='w-full flex items-center justify-between mt-[25px]'>
                      <span className='text-[#ac9999] text-[14px]'>{item?.duration}</span>
                      <div className='flex justify-between items-center'>
                        <Image
                          style={{ cursor: 'pointer' }}
                          src='/images/record-surround/download.svg'
                          width={24}
                          height={24}
                          alt='download'
                          onClick={e => {
                            e.stopPropagation()
                            setVedioUrl('')
                            downloadVideo(item.url)
                          }}
                        />
                        {/* <Image
                          className='ml-[18px]'
                          style={{ cursor: 'pointer' }}
                          src='/images/record-surround/play.svg'
                          width={24}
                          height={24}
                          alt='play'
                          onClick={() => setVedioUrl(item.url)}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* PC端 */}
                <div className='Bld:hidden'>
                  <div
                    className='h-[103px] rounded-[6px] flex shadow-[0_0_5px_rgba(0,0,0,0.3)] my-[5px] justify-between items-center pl-[38px] pr-[70px] cursor-pointer'
                    onClick={() => setVedioUrl(item.url)}
                  >
                    <Checkbox
                      checked={item.checked}
                      onChange={e => {
                        e.stopPropagation()
                        setVedioUrl('')
                        onChangeChecked(e, i)
                      }}
                      className='text-[#ac9999] text-[14px]'
                    ></Checkbox>
                    <span className='text-[16px] text-[#333333] font-[600]'>{item.date}</span>
                    <span className='text-[#ac9999] text-[14px]'>{item?.duration}</span>
                    {/* <Image
                      className='ml-[18px]'
                      style={{ cursor: 'pointer' }}
                      src='/images/record-surround/play.svg'
                      width={24}
                      height={24}
                      alt='play'
                      onClick={() => setVedioUrl(item.url)}
                    /> */}
                    <Image
                      style={{ cursor: 'pointer' }}
                      src='/images/record-surround/download.svg'
                      width={24}
                      height={24}
                      alt='download'
                      onClick={e => {
                        e.stopPropagation()
                        setVedioUrl('')
                        downloadVideo(item.url)
                      }}
                    />
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        </div>
        {vedioUrl && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            className='absolute w-full h-full bg-[rgba(0,0,0,0.5)] flex justify-center items-center'
            onClick={() => {
              setVedioUrl('')
            }}
          >
            <audio
              src={vedioUrl}
              controls={true}
              autoPlay={true}
              id='video'
              preload='none'
              loop={false}
              muted={false}
            ></audio>
          </motion.div>
        )}
        {isLoading ? (
        <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
          <ContentLoading />
        </div>
      ) : null}
{(allVideoData.length > 0 || isLoading) ||
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </div>
  )
}

export default RecordSurround



{
  /* <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginBottom: '10px'
        }}
      >
        <Dropdown
          menu={{
            items,
            onClick: e => recordNow(e)
          }}
          disabled={btnLoading}
        >
          <Button
            loading={btnLoading}
            style={{
              background: 'rgb(80, 227, 194)',
              color: 'rgb(255, 255, 255)'
            }}
          >
            <Space>
              {btnLoading ? 'While recording, make sure your phone screen is on and don’t leave it' : 'Record Now'}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </div>
      <Box sx={{ overflow: 'auto' }} style={{ height: 'calc(var(--vh2)*100 - 340px)' }}>
        <PerfectScrollbar style={{ background: '#fff' }}>
          <TableContainer component={Paper}>
            <Table sx={{}} size='small' aria-label='a dense table'>
              <TableRow>
                <TableCell style={{ textAlign: 'center', fontWeight: '700' }}>Date</TableCell>
                <TableCell style={{ textAlign: 'center', fontWeight: '700' }}>Audio</TableCell>
              </TableRow>

              {videoData instanceof Array
                ? videoData.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell style={{ textAlign: 'center' }}>{row.date}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>
                        <Icon
                          icon='ic:baseline-slow-motion-video'
                          style={{ margin: '0 auto', cursor: 'pointer' }}
                          onClick={() => audio(`${row.url}`)}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                : null}
            </Table>
          </TableContainer>
        </PerfectScrollbar>
      </Box>
      <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
        <Pagination defaultCurrent={page} onChange={e => setPage(e)} total={total} />
      </Box>

      <Modal
        title=''
        closable={false}
        open={videoOpen}
        onCancel={() => setVideoOpen(false)}
        footer={[]}
        width={360}
        style={{ marginTop: '20px' }}
      >
        <audio
          src={currentVideo}
          controls={true}
          autoPlay={true}
          id='video'
          preload='none'
          loop={false}
          muted={false}
        ></audio>
      </Modal>
      {contextHolder}
    </div> */
}
